/**
 * GÖKOTTA EC — friction reduction (Phase A0) + Made in Japan chrome helpers
 * UX = u + e - f  →  f↓ が目的
 *
 * 1. scroll-jack スライダーの scroll ハンドラ無効化
 * 2. 言語選択フォームの意図しない submit 防止（ダブルチェック）
 * 3. 内部リンク: /collections/products/products/ → /products/ へ書き換え
 * 4. コレクションカード／カートに静かな Made in Japan 印（ORIGIN-UX.md Layer 2 / 4）
 * 5. PDP ATC直下に送料・返品（snippet未挿入時のフォールバック / L3）
 * 6. PDP ATC付近に作家名・ギフト一言（JSON-LD / L3-B）
 */
(function () {
  'use strict';

  var NESTED_PATH = /^(.*?)\/collections\/products\/products\/([^/?#]+)(.*)$/;
  var CARD_SEL =
    '.product-item, .card--product, .product-card, [data-product-item], .grid-product';
  var CART_SEL =
    'cart-drawer .cart-drawer__footer, cart-drawer .drawer__footer, #CartDrawer .drawer__footer, .cart__footer, .cart-drawer__footer, [data-cart-footer]';
  var FREE_SHIP_YEN = 20000;

  function rewriteProductHref(href) {
    if (!href || href.indexOf('/collections/products/products/') === -1) return href;
    var m = href.match(NESTED_PATH);
    if (!m) return href;
    /* prefix（/en 等）と suffix（?variant= / #）を保持 */
    return m[1] + '/products/' + decodeURIComponent(m[2]) + m[3];
  }

  function fixProductLinks(root) {
    var scope = root || document;
    scope.querySelectorAll('a[href]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href) return;
      var next = rewriteProductHref(href);
      if (next !== href) a.setAttribute('href', next);
    });
  }

  /** ネストURLで開いたときアドレスバーを正規URLへ（SEOはS1リダイレクトが本命） */
  function normalizeNestedLocation() {
    var path = window.location.pathname || '';
    if (path.indexOf('/collections/products/products/') === -1) return;
    var m = path.match(NESTED_PATH);
    if (!m) return;
    var next =
      m[1] +
      '/products/' +
      decodeURIComponent(m[2]) +
      (window.location.search || '') +
      (window.location.hash || '');
    var current = path + (window.location.search || '') + (window.location.hash || '');
    if (next !== current && window.history && window.history.replaceState) {
      window.history.replaceState(null, '', next);
    }
  }

  function disableScrollJackSlideshow() {
    document.querySelectorAll('image-slideshow.slider--scroll').forEach(function (el) {
      el.classList.remove('slider--scroll');
      el.dataset.gokottaScrollDisabled = 'true';
    });
  }

  var linkFixScheduled = false;
  function scheduleFixProductLinks() {
    if (linkFixScheduled) return;
    linkFixScheduled = true;
    requestAnimationFrame(function () {
      linkFixScheduled = false;
      fixProductLinks(document);
    });
  }

  function guardLocalizationForms() {
    document.querySelectorAll('form.localization-form').forEach(function (form) {
      form.addEventListener(
        'submit',
        function (ev) {
          if (form.dataset.gokottaLocaleConfirmed !== 'true') {
            ev.preventDefault();
            ev.stopImmediatePropagation();
          }
        },
        true
      );
    });
    document.querySelectorAll('[data-js-localization-form-content] a, [data-js-localization-form-content] button, [data-js-localization-form-content] input').forEach(function (item) {
      item.addEventListener('click', function () {
        var form = item.closest('form.localization-form');
        if (form) {
          form.dataset.gokottaLocaleConfirmed = 'true';
          item.dataset.gokottaUserSelected = 'true';
        }
      });
    });
    /* 明示的な言語ボタン（テーマ差異用） */
    document.querySelectorAll('button.regular-select-cover, .localization-form button[type="submit"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var form = btn.closest('form.localization-form');
        if (form) form.dataset.gokottaLocaleConfirmed = 'true';
      });
    });
  }

  function isJaLocale() {
    var htmlLang = (document.documentElement.lang || '').toLowerCase();
    if (htmlLang.indexOf('ja') === 0) return true;
    return window.location.pathname.indexOf('/en') !== 0;
  }

  function markProductCards(root) {
    var scope = root || document;
    scope.querySelectorAll(CARD_SEL).forEach(function (card) {
      if (card.querySelector('.gokotta-card-origin')) return;
      /* skip gift wrapping / non-GÖKOTTA noise if marked */
      if (card.getAttribute('data-gokotta-skip-origin') === 'true') return;

      var mark = document.createElement('span');
      mark.className = 'gokotta-card-origin';
      mark.textContent = 'Made in Japan';
      mark.setAttribute('aria-label', 'Made in Japan');

      var title =
        card.querySelector(
          '.product-item__title, .card__heading, .product-card__title, .product-title, h3, h2'
        ) || null;
      var price = card.querySelector(
        '.product-item__price, .price, .card__price, .product-card__price'
      );

      if (title && title.parentNode) {
        if (price && price.parentNode === title.parentNode) {
          price.insertAdjacentElement('afterend', mark);
        } else {
          title.insertAdjacentElement('afterend', mark);
        }
      } else if (price) {
        price.insertAdjacentElement('afterend', mark);
      } else {
        card.appendChild(mark);
      }
    });
  }

  function markCartOrigin(root) {
    var scope = root || document;
    scope.querySelectorAll(CART_SEL).forEach(function (footer) {
      if (footer.querySelector('.gokotta-cart-origin')) return;
      var line = document.createElement('p');
      line.className = 'gokotta-cart-origin';
      if (isJaLocale()) {
        line.innerHTML = '<strong>Made in Japan</strong> — 日本の工房からお届けします';
      } else {
        line.innerHTML =
          '<strong>Made in Japan</strong> — Crafted in inclusive workshops in Japan';
      }
      footer.insertAdjacentElement('afterbegin', line);
    });
  }

  function parseYenFromDom() {
    /* 現行テーマは .product__price / .product__price--original（.money なし） */
    var el =
      document.querySelector(
        '.product__price--original, .product__price .price-item--sale, .price-item--sale, .price-item--regular, .price__regular .price-item, [data-product-price], .product__price .money, .product__price'
      ) || document.querySelector('.price .money, .product-price, .price');
    if (!el) return null;
    var raw = (el.textContent || '').replace(/,/g, '');
    var m = raw.match(/(?:¥|￥)?\s*(\d{3,})/);
    return m ? parseInt(m[1], 10) : null;
  }

  function atcTrustAnchor() {
    return (
      document.querySelector('.shopify-payment-button') ||
      document.querySelector('.product-form__buttons') ||
      document.querySelector('button[name="add"]') ||
      document.querySelector('.product-form__submit') ||
      document.querySelector('form[action*="/cart/add"] button[type="submit"]')
    );
  }

  function atcInsertAfter() {
    var anchor = atcTrustAnchor();
    if (!anchor || !anchor.parentNode) return null;
    return anchor.classList.contains('shopify-payment-button')
      ? anchor
      : anchor.closest('.product-form__buttons') || anchor;
  }

  function walkLdNodes(node, out) {
    if (!node) return;
    if (Array.isArray(node)) {
      node.forEach(function (n) {
        walkLdNodes(n, out);
      });
      return;
    }
    if (typeof node !== 'object') return;
    out.push(node);
    if (node['@graph']) walkLdNodes(node['@graph'], out);
  }

  function readProductLd() {
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    var nodes = [];
    for (var i = 0; i < scripts.length; i++) {
      try {
        walkLdNodes(JSON.parse(scripts[i].textContent || 'null'), nodes);
      } catch (e) {
        /* ignore bad JSON-LD */
      }
    }
    for (var j = 0; j < nodes.length; j++) {
      var n = nodes[j];
      var t = n['@type'];
      var isProduct =
        t === 'Product' ||
        (Array.isArray(t) && t.indexOf('Product') !== -1);
      if (isProduct) return n;
    }
    return null;
  }

  function artistFromLd(product) {
    if (!product) return '';
    var c = product.creator;
    if (!c) return '';
    if (typeof c === 'string') return c;
    if (Array.isArray(c)) {
      var first = c[0];
      if (!first) return '';
      return typeof first === 'string' ? first : first.name || '';
    }
    return c.name || '';
  }

  function giftSuitableFromLd(product) {
    if (!product || !product.additionalProperty) return false;
    var props = Array.isArray(product.additionalProperty)
      ? product.additionalProperty
      : [product.additionalProperty];
    for (var i = 0; i < props.length; i++) {
      var p = props[i];
      if (!p || !p.name) continue;
      var key = String(p.name).toLowerCase();
      if (key === 'giftsuitable' || key === 'gift_suitable' || key === 'gift') {
        return p.value === true || p.value === 'true' || p.value === 1 || p.value === '1';
      }
    }
    return false;
  }

  /** L3-B: 作家・ギフトをATC直後に（説明欄より上＝決断層） */
  function injectAtcStoryCue() {
    if (!document.body || !/\/products\//.test(window.location.pathname || '')) return;
    if (document.querySelector('[data-gokotta-atc-story]')) return;
    var insertAfter = atcInsertAfter();
    if (!insertAfter) return;

    var product = readProductLd();
    var artist = artistFromLd(product).trim();
    var gift = giftSuitableFromLd(product);
    if (!gift && document.querySelector('.gokotta-badge')) {
      var badges = document.querySelectorAll('.gokotta-badge');
      for (var b = 0; b < badges.length; b++) {
        if (/^\s*gift\s*$/i.test(badges[b].textContent || '')) {
          gift = true;
          break;
        }
      }
    }
    if (!artist && !gift) return;

    var ja = isJaLocale();
    var parts = [];
    if (artist) {
      parts.push(
        (ja ? '作家: ' : 'Artist: ') +
          '<strong class="notranslate" translate="no">' +
          artist.replace(/</g, '&lt;') +
          '</strong>'
      );
    }
    if (gift) {
      parts.push(ja ? 'ギフト・お土産にも' : 'Also great as a gift or souvenir');
    }

    var p = document.createElement('p');
    p.className = 'gokotta-atc-story';
    p.setAttribute('data-gokotta-atc-story', 'js');
    p.setAttribute('role', 'note');
    p.innerHTML = parts.join(' <span aria-hidden="true">·</span> ');

    var trust = document.querySelector('[data-gokotta-atc-trust]');
    if (trust && trust.parentNode) {
      trust.insertAdjacentElement('beforebegin', p);
    } else {
      insertAfter.insertAdjacentElement('afterend', p);
    }
  }

  /** snippet 未 render 時のフォールバック。Liquid版があれば何もしない */
  function injectAtcTrust() {
    if (!document.body || !/\/products\//.test(window.location.pathname || '')) return;
    if (document.querySelector('[data-gokotta-atc-trust]')) return;
    var insertAfter = atcInsertAfter();
    if (!insertAfter) return;

    var ja = isJaLocale();
    var yen = parseYenFromDom();
    var shipHref = ja ? '/pages/shipping-gift' : '/en/pages/shipping-gift';
    var refundHref = ja ? '/policies/refund-policy' : '/en/policies/refund-policy';
    var shipLine;
    if (ja) {
      shipLine = '国内配送: <strong>20,000円以上送料無料</strong>';
      if (yen != null && yen < FREE_SHIP_YEN) {
        shipLine +=
          '（この商品だと<strong>あと' + (FREE_SHIP_YEN - yen) + '円</strong>）';
      } else if (yen != null) {
        shipLine += '（この商品は送料無料条件を満たします）';
      }
    } else {
      shipLine = 'Japan domestic: <strong>free shipping over ¥20,000</strong>';
      if (yen != null && yen < FREE_SHIP_YEN) {
        shipLine +=
          ' (about <strong>¥' + (FREE_SHIP_YEN - yen) + '</strong> more with this item)';
      } else if (yen != null) {
        shipLine += ' (this item qualifies)';
      }
    }

    var p = document.createElement('p');
    p.className = 'gokotta-atc-trust';
    p.setAttribute('data-gokotta-atc-trust', 'js');
    p.setAttribute('role', 'note');
    p.innerHTML =
      '<span class="gokotta-atc-trust__ship">' +
      shipLine +
      '</span><span class="gokotta-atc-trust__links"><a href="' +
      shipHref +
      '">' +
      (ja ? '配送・ギフト' : 'Shipping &amp; gifts') +
      '</a> <span aria-hidden="true">·</span> <a href="' +
      refundHref +
      '">' +
      (ja ? '返品' : 'Returns') +
      '</a></span>';

    insertAfter.insertAdjacentElement('afterend', p);
  }

  function runAtcInjections() {
    injectAtcTrust();
    injectAtcStoryCue();
  }

  var originScheduled = false;
  function scheduleOriginMarks() {
    if (originScheduled) return;
    originScheduled = true;
    requestAnimationFrame(function () {
      originScheduled = false;
      markProductCards(document);
      markCartOrigin(document);
      runAtcInjections();
    });
  }

  function init() {
    normalizeNestedLocation();
    fixProductLinks(document);
    disableScrollJackSlideshow();
    guardLocalizationForms();
    markProductCards(document);
    markCartOrigin(document);
    runAtcInjections();

    /* 動的コンテンツ — rAF でバッチ処理 */
    var observer = new MutationObserver(function () {
      scheduleFixProductLinks();
      scheduleOriginMarks();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
